import { Utility } from "./utility";
var Assessment = /** @class */ (function () {
    function Assessment() {
        this.id = null;
        this.display_order = 1;
        this.enabled = 1;
        this.instructions = "";
        this.display_client_results = true;
        this.question_sets = [];
        this.scales = [];
        this.version = 1;
        // TODO: stephen when we expand to other tests we need to change this.
        this.name = "";
        this.uid = "";
        this.resourcesURL = "";
        this.creator = "";
        this.creatorUrl = "";
        this.description = "";
        this.isPublic = false;
    }
    Object.defineProperty(Assessment.prototype, "creator", {
        get: function () {
            return this._creator;
        },
        set: function (v) {
            this._creator = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Assessment.prototype, "description", {
        get: function () {
            return this._description;
        },
        set: function (v) {
            this._description = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Assessment.prototype, "creatorUrl", {
        get: function () {
            return this._creatorUrl;
        },
        set: function (v) {
            this._creatorUrl = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Assessment.prototype, "resourcesURL", {
        get: function () {
            return this._resourcesURL;
        },
        set: function (v) {
            this._resourcesURL = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Assessment.prototype, "uid", {
        get: function () {
            return this._uid;
        },
        set: function (v) {
            this._uid = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Assessment.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (v) {
            this._name = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Assessment.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (id) {
            this._id = id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Assessment.prototype, "display_order", {
        get: function () {
            return this._display_order;
        },
        set: function (order) {
            this._display_order = order;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Assessment.prototype, "enabled", {
        get: function () {
            return this._enabled;
        },
        set: function (enable) {
            this._enabled = enable;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Assessment.prototype, "instructions", {
        get: function () {
            return this._instructions;
        },
        set: function (desc) {
            this._instructions = desc;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Assessment.prototype, "display_client_results", {
        get: function () {
            return this._display_client_results;
        },
        set: function (display) {
            this._display_client_results = display;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Assessment.prototype, "question_sets", {
        get: function () {
            return this._question_sets;
        },
        set: function (sets) {
            this._question_sets = sets;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Assessment.prototype, "scales", {
        get: function () {
            return this._scales;
        },
        set: function (scales) {
            this._scales = scales;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Assessment.prototype, "version", {
        get: function () {
            return this._version;
        },
        set: function (version) {
            this._version = version;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Assessment.prototype, "therapistDescription", {
        get: function () {
            return this._therapistDescription;
        },
        set: function (value) {
            this._therapistDescription = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Assessment.prototype, "isPublic", {
        get: function () {
            return this._isPublic;
        },
        set: function (value) {
            this._isPublic = value;
        },
        enumerable: true,
        configurable: true
    });
    Assessment.prototype.addQuestionSet = function (qs) {
        this.question_sets.push(qs);
    };
    Assessment.prototype.removeQuestionSet = function (qs) {
        var index = this.question_sets.indexOf(qs);
        if (index >= 0) {
            this.question_sets.splice(index, 1);
        }
    };
    Assessment.prototype.addScale = function (scale) {
        this.scales.push(scale);
    };
    Assessment.prototype.removeScale = function (scale) {
        var index = this.scales.indexOf(scale);
        if (index >= 0) {
            this.scales.splice(index, 1);
            this.question_sets.forEach(function (q) { return q.removeScale(scale); });
        }
    };
    Assessment.prototype.getQuestionsForScale = function (scale) {
        var questions = [];
        this.question_sets.forEach(function (qs) {
            var qsQuestions = qs.questions.filter(function (q) { return q.assessment_scale.id === scale.id; });
            questions = questions.concat(qsQuestions);
        });
        return questions;
    };
    Assessment.prototype.shiftScaleUp = function (scale) {
        Utility.shiftCollectionUp(this._scales, scale);
    };
    Assessment.prototype.shiftScaleDown = function (scale) {
        Utility.shiftCollectionDown(this._scales, scale);
    };
    Assessment.prototype.shiftQuestionSetUp = function (questionSet) {
        Utility.shiftCollectionUp(this._question_sets, questionSet);
    };
    Assessment.prototype.shiftQuestionSetDown = function (questionSet) {
        Utility.shiftCollectionDown(this._question_sets, questionSet);
    };
    Assessment.prototype.getQuestionSetsForDisplay = function () {
        var _this = this;
        return this._question_sets.filter(function (qs) { return _this.shouldDisplayQuestionSet(qs); });
    };
    Assessment.prototype.shouldDisplayQuestionSet = function (qs) {
        var _this = this;
        var displayConditions = qs.getDisplayConditions();
        if (!displayConditions || !displayConditions.length) {
            return true;
        }
        var showRatings = displayConditions.map(function (dc) { return dc.getDisplay(_this); });
        // TODO: stephen when we can have multiple conditions we need to have some kind of point ranking
        // or other system for this
        if (showRatings.length) {
            if (showRatings[0] === 'hide') {
                return false;
            }
        }
        return true;
    };
    Assessment.prototype.getFirstQuestionSetToDisplay = function () {
        var questionSets = this.getQuestionSetsForDisplay();
        if (questionSets.length) {
            return questionSets[0];
        }
        return null;
    };
    Assessment.prototype.getQuestionSetById = function (id) {
        var set = this._question_sets.find(function (qs) { return qs.id == id; });
        return set;
    };
    Assessment.prototype.getQuestionsListById = function () {
        var questionsById = (this._question_sets || [])
            .map(function (qs) { return qs.questions || []; }) // grab the questions
            .reduce(function (prev, curr) { return prev.concat(curr); }, []) // concatenate all the arrays
            .reduce(function (prev, curr) { prev[curr.id] = curr; return prev; }, {}); // now return the questions by their ids, every question id is unique
        return questionsById;
    };
    Assessment.prototype.getNextQuestionSetToDisplay = function (questionSet) {
        var index = this._question_sets.indexOf(questionSet);
        if (index < 0) {
            throw new Error("The question set could not be found with id " + questionSet.id);
        }
        for (var i = index + 1; i < this._question_sets.length; i++) {
            if (this.shouldDisplayQuestionSet(this._question_sets[i])) {
                return this._question_sets[i];
            }
        }
        return null;
    };
    Assessment.prototype.getPreviousQuestionSetToDisplay = function (questionSet) {
        var index = this._question_sets.indexOf(questionSet);
        if (index < 0) {
            throw new Error("The question set could not be found with id " + questionSet.id);
        }
        for (var i = index - 1; i >= 0; i--) {
            if (this.shouldDisplayQuestionSet(this._question_sets[i])) {
                return this._question_sets[i];
            }
        }
        return null;
    };
    Assessment.prototype.getFlaggedQuestions = function () {
        var questions = [];
        var flaggedQuestions = this.question_sets.map(function (qs) {
            return qs.questions.filter(function (q) { return q.isFlaggedForReview; });
        })
            .filter(function (questions) { return questions.length; })
            .reduce(function (prev, cur) {
            return cur.concat(prev);
        }, []);
        return flaggedQuestions;
    };
    return Assessment;
}());
export { Assessment };



// WEBPACK FOOTER //
// ./src/app/shared/models/assessment.ts.pre-build-optimizer.js